import { ref, onMounted, nextTick, computed, onUnmounted } from "vue";
import { useForm } from "@/views/login/index";
import { useRouter } from "vue-router";
import Swal from "sweetalert2";
import { config } from "@/config"; // Importar la configuración
import { getUser, clearUser, setUserFromToken, hasPermission } from "@/store/userStore";
import { PerfilService } from "@/services/PerfilService";
import { CarritoService } from "@/services/CarritoService";
import { RepuestoService } from "@/services/RepuestoService";
import EventBus from "@/EventBus";
import { useStore } from "vuex";
import { formatCurrency } from "@/utils/formatPrice";
import { User2Icon, UserIcon } from 'lucide-vue-next';
export default {
    name: "Header",
    components: {
        User2Icon,
        UserIcon
    },
    setup() {
        const { showSignIn, showSignUp } = useForm();
        const searchQuery = ref("");
        const store = useStore();
        const router = useRouter();
        const user = ref(null);
        const cartItems = ref([]);
        const totalAmount = ref(0);
        const isCartOpen = ref(false); // Estado para el carrito
        const showMenu = ref(false);
        const repuestos = ref([]);
        const profileImage = ref(require("@/assets/perfil.png"));
        const currentPage = ref(1); // Página actual
        const itemsPerPage = ref(4); // Número de productos por página
        const currentPage2 = ref(1); // Página actual
        const itemsPerPage2 = ref(4); // Número de productos por página
        // Definir el tamaño del icono
        const iconSize = ref(window.innerWidth <= 480 ? 24 : 18);
        // Función para actualizar el tamaño del icono en móviles
        const updateIconSize = () => {
            iconSize.value = window.innerWidth <= 480 ? 24 : 18;
        };
        const paginatedCartItems = computed(() => {
            const sortedItems = [...cartItems.value].sort((a, b) => {
                // Asumiendo que quieres ordenar por propiedad 'nombre' alfabéticamente
                const nameA = a.producto.repuesto.nombre.toLowerCase();
                const nameB = b.producto.repuesto.nombre.toLowerCase();
                if (nameA < nameB)
                    return -1;
                if (nameA > nameB)
                    return 1;
                return 0;
            });
            const start = (currentPage.value - 1) * itemsPerPage2.value;
            const end = start + itemsPerPage.value;
            return sortedItems.slice(start, end);
        });
        const totalPages = computed(() => Math.ceil(cartItems.value.length / itemsPerPage.value));
        const nextPage = () => {
            if (currentPage.value < totalPages.value)
                currentPage.value++;
        };
        const prevPage = () => {
            if (currentPage.value > 1)
                currentPage.value--;
        };
        const paginatedCartItems2 = computed(() => {
            const sortedItems = [...cartItems.value].sort((a, b) => {
                // Asumiendo que quieres ordenar por propiedad 'nombre' alfabéticamente
                const nameA = a.producto.repuesto.nombre.toLowerCase();
                const nameB = b.producto.repuesto.nombre.toLowerCase();
                if (nameA < nameB)
                    return -1;
                if (nameA > nameB)
                    return 1;
                return 0;
            });
            const start = (currentPage2.value - 1) * itemsPerPage2.value;
            const end = start + itemsPerPage2.value;
            return sortedItems.slice(start, end);
        });
        const totalPages2 = computed(() => Math.ceil(cartItems.value.length / itemsPerPage2.value));
        const nextPage2 = () => {
            if (currentPage2.value < totalPages2.value)
                currentPage2.value++;
        };
        const prevPage2 = () => {
            if (currentPage2.value > 1)
                currentPage2.value--;
        };
        formatCurrency;
        // Función para manejar la búsqueda
        const performSearch = () => {
            if (searchQuery.value.trim()) {
                // Redirigir a la página de resultados de búsqueda
                router.push({ path: "/productos", query: { q: searchQuery.value } });
            }
            else {
                Swal.fire("Por favor ingrese un término de búsqueda.");
            }
        };
        onUnmounted(() => {
            window.removeEventListener('resize', updateIconSize);
        });
        onMounted(async () => {
            window.addEventListener('resize', updateIconSize);
            EventBus.on("cartUpdated", handleCartUpdate);
            user.value = getUser();
            if (!user.value) {
                const token = localStorage.getItem("accessToken");
                if (token) {
                    setUserFromToken(token);
                    user.value = getUser();
                }
            }
            if (user.value) {
                await fetchProfileImage();
                await fetchCarritoUser();
            }
        });
        function getPortadaImage(imagenes) {
            const portadaImage = imagenes.find((img) => img.portada);
            if (!portadaImage)
                return "";
            return portadaImage.imagen.startsWith('http') ? portadaImage.imagen : `${config.API_URL}${portadaImage.imagen}`;
        }
        async function fetchProfileImage() {
            if (user.value) {
                try {
                    const response = await PerfilService.getProfileN();
                    if (response.imagenPerfil) {
                        profileImage.value = `${config.API_URL}${response.imagenPerfil}`;
                    }
                }
                catch (error) {
                    console.error("Error al obtener la imagen del perfil:", error);
                }
            }
        }
        // Función para actualizar el total del carrito
        function updateTotalAmount() {
            const total = cartItems.value.reduce((sum, item) => sum + item.cantidad * item.precio, 0);
            totalAmount.value = total;
        }
        function handleCartUpdate() {
            fetchCarritoUser(); // Actualiza el carrito cuando el evento se emite
        }
        // Función para incrementar la cantidad de un ítem en el carrito
        async function incrementQuantity(itemID) {
            const item = cartItems.value.find((i) => i.detalleCarritoID === itemID);
            if (item) {
                const newQuantity = item.cantidad + 1;
                try {
                    const result = await CarritoService.updateDetalle(itemID, newQuantity);
                    // Confirmar que la actualización fue exitosa antes de actualizar la UI
                    if (result) {
                        item.cantidad = newQuantity;
                        fetchCarritoUser();
                        EventBus.emit("cartUpdated");
                    }
                    else {
                        console.error("Error al confirmar la actualización en el backend.");
                        // Puedes agregar un mensaje para el usuario si es necesario
                    }
                }
                catch (error) {
                    console.error("Error al actualizar la cantidad:", error);
                    // Revertir el incremento en caso de error
                    item.cantidad--;
                }
            }
        }
        // Función para decrementar la cantidad de un ítem en el carrito
        async function decrementQuantity(itemID) {
            const item = cartItems.value.find((i) => i.detalleCarritoID === itemID);
            if (item && item.cantidad > 1) {
                try {
                    // Enviar la solicitud para actualizar la cantidad en el backend
                    const result = await CarritoService.updateDetalle(itemID, item.cantidad - 1);
                    // Confirmar que la actualización fue exitosa antes de actualizar la UI
                    if (result) {
                        item.cantidad--;
                        fetchCarritoUser();
                        EventBus.emit("cartUpdated");
                    }
                    else {
                        console.error("Error al confirmar la actualización en el backend.");
                    }
                }
                catch (error) {
                    console.error("Error al actualizar la cantidad:", error);
                    // Mantener la cantidad sin cambios en caso de error
                }
            }
        }
        // Función para actualizar la cantidad de un ítem en el carrito
        async function updateQuantity(item) {
            try {
                const result = await CarritoService.updateDetalle(item.detalleCarritoID, item.cantidad);
                // Confirmar que la actualización fue exitosa
                if (result) {
                    fetchCarritoUser();
                    EventBus.emit("cartUpdated");
                }
            }
            catch (error) {
                console.error("Error al actualizar la cantidad:", error);
                // Manejar el error de acuerdo a tus necesidades
            }
        }
        async function fetchCarritoUser() {
            try {
                const datos = await CarritoService.getCarritoUser(); // Llama al servicio
                // Verifica si 'datos' es nulo antes de acceder a 'detallesCarrito'
                if (!datos || !datos.detallesCarrito) {
                    cartItems.value = []; // Inicializa con un carrito vacío en la UI
                    totalAmount.value = 0;
                    return;
                }
                console.log(cartItems);
                // Asigna los detalles del carrito si están disponibles
                cartItems.value = datos.detallesCarrito;
                totalAmount.value = cartItems.value.reduce((acc, item) => acc + item.producto.precioVenta * item.cantidad, 0);
            }
            catch (error) {
                Swal.fire({
                    title: "Error",
                    text: error.message || "Error al obtener el carrito",
                    icon: "error",
                });
            }
        }
        async function vaciarCarrito() {
            const result = await Swal.fire({
                title: "¿Estás seguro?",
                text: "Esta acción eliminará todos los productos de tu carrito. No podrás revertirla.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, vaciar carrito",
                cancelButtonText: "Cancelar",
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
            });
            if (result.isConfirmed) {
                try {
                    // Llama al servicio para vaciar el carrito en el backend
                    await CarritoService.vaciarCarrito();
                    // Limpia el estado local del carrito en la UI
                    cartItems.value = [];
                    totalAmount.value = 0;
                    // Emite el evento por si otro componente necesita saber del cambio
                    EventBus.emit("cartUpdated");
                    Swal.fire({
                        title: "¡Listo!",
                        text: "Tu carrito ha sido vaciado.",
                        icon: "success",
                        timer: 2000,
                        showConfirmButton: false
                    });
                }
                catch (error) {
                    Swal.fire({
                        title: "Error",
                        text: error.message || "No se pudo vaciar el carrito. Inténtalo de nuevo.",
                        icon: "error",
                    });
                }
            }
        }
        // Método para obtener repuestos de la API
        const fetchRepuestos = async () => {
            try {
                repuestos.value = await RepuestoService.getAllRepuestos();
            }
            catch (error) {
                console.error("Error al cargar repuestos:", error);
                // Agregar manejo de errores para la interfaz de usuario
            }
        };
        function goToLogin() {
            router.push("/login");
            showSignIn();
        }
        function goToRegister() {
            router.push("/login");
            showSignUp();
        }
        function toggleCart() {
            isCartOpen.value = !isCartOpen.value;
        }
        async function removeItem(detalleCarritoID) {
            try {
                await CarritoService.deleteDetalle(detalleCarritoID);
                cartItems.value = cartItems.value.filter((item) => item.detalleCarritoID !== detalleCarritoID);
                totalAmount.value = cartItems.value.reduce((acc, item) => acc + item.producto.precioVenta * item.cantidad, 0);
                EventBus.emit("cartUpdated");
            }
            catch (error) {
                Swal.fire({
                    title: "Error",
                    text: "No se pudo eliminar el ítem.",
                    icon: "error",
                    customClass: {
                        confirmButton: "swal-button--confirm-custom",
                    },
                });
            }
        }
        function logout() {
            Swal.fire({
                title: "¿Estás seguro?",
                text: "Tu sesión será cerrada.",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Sí, cerrar sesión",
                cancelButtonText: "Cancelar",
                customClass: {
                    confirmButton: "swal-button--confirm-custom",
                    cancelButton: "swal-button--cancel-custom",
                },
            }).then((result) => {
                if (result.isConfirmed) {
                    localStorage.removeItem("accessToken");
                    localStorage.removeItem("refreshToken");
                    clearUser();
                    user.value = null;
                    router.push("/").then(() => {
                        window.location.reload();
                    });
                }
            });
        }
        function focusNextQuantity(index) {
            nextTick(() => {
                const nextInput = document.querySelector(`#quantity-${index + 1}`);
                if (nextInput) {
                    nextInput.focus();
                }
            });
        }
        return {
            user,
            profileImage,
            cartItems,
            totalAmount,
            getPortadaImage,
            goToLogin,
            goToRegister,
            logout,
            showMenu,
            removeItem,
            toggleCart,
            isCartOpen,
            incrementQuantity,
            decrementQuantity,
            updateQuantity,
            performSearch,
            searchQuery,
            focusNextQuantity,
            fetchRepuestos,
            formatCurrency,
            currentPage,
            nextPage,
            prevPage,
            totalPages,
            currentPage2,
            nextPage2,
            prevPage2,
            totalPages2,
            paginatedCartItems,
            paginatedCartItems2,
            vaciarCarrito,
            iconSize,
            hasPermission
        };
    },
};
